import styled from 'styled-components';

export const Cover = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

export default Cover;
